// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__3ubwU","summary":"CartItem_summary__dwOHq","price":"CartItem_price__L16FC","amount":"CartItem_amount__I3B-J","actions":"CartItem_actions__x+pxB"};